import { request } from '@/shared/api/request'

export const getAffairForEmployerByCorrelationId = (id) =>
    request({
        url: `contract/persCard/getCardCorr?correlationId=${id}`,
        method: 'GET'
    })
